import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Switch from 'react-switch';
import { loaderActions } from "../../../../_actions/loader.actions";
import "../../../../assets/css/master.css";
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import PasswordInput from '../../../../customControl/PasswordInput';
import { ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { getuserprofileimagebyid } from '../../../commonClass/CommonFunctions';
import { countrystatecityregion } from '../../../commonClass/CommonInterfaceTypes';
import { CheckPassword, isValidEmail, onlyAlphabets, onlyNumeric } from '../../../commonClass/CommonValidation';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { UserModel } from '../../modals/RightsModel';


function getDateCombination() {
    const today = new Date();
    const date =
        today?.getFullYear()?.toString() +
        (today?.getMonth() + 1)?.toString() +
        today?.getDate()?.toString();
    const time =
        today?.getHours()?.toString() +
        (today?.getMinutes() + 1)?.toString() +
        today?.getSeconds()?.toString();
    return date + "_" + time;
}
interface SelectList {
    value: number,
    label: string,
}
interface DepatmentSelectList {
    departmentId: number,
    departmentName: string,
    value: number,
    label: string,
    departmentRoleList: RoleList[],
}
interface RoleList {
    roleId: number,
    roleName: string,
    userType: number,
    value: number,
    label: string,
}
interface DomainMasterList {
    DomainMasterId: number,
    DomainName: string,
    value: number,
    label: string,
}
interface CorporateManagementList {
    CorporateId: number,
    NameOfCompany: string,
    value: number,
    label: string,
}
interface TravelAgentManagementList {
    TravelAgentId: number,
    TravelAgentName: string,
    value: number,
    label: string,
}
interface DropDownList {
    corporateManagement: CorporateManagementList[],
    departmentRoleList: DepatmentSelectList[],
    domainMaster: DomainMasterList[],
    travelAgentManagement: TravelAgentManagementList[],
}
class DropDownListClass {
    corporateManagement: CorporateManagementList[];
    departmentRoleList: DepatmentSelectList[];
    domainMaster: DomainMasterList[];
    travelAgentManagement: TravelAgentManagementList[];

    constructor() {
        this.corporateManagement = [];
        this.departmentRoleList = [];
        this.domainMaster = [];
        this.travelAgentManagement = [];
    }
}

const Useradd = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const locationsData: countrystatecityregion = useSelector((store: any) => store.locationsdata.data);
    const [modalShow, setModalShow] = useState(false);
    const [formErrors, setFormErrors] = useState<any>({});
    const [GenderList, setGenderList] = useState<SelectList[]>([]);
    const [ProductList, setProductList] = useState<SelectList[]>([]);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(false);
    const [activeId, setActiveId] = useState(false);
    const [disable, setDisabled] = useState(false)
    const [passwordType, setPasswordType] = useState(false);
    const [formData, setFormData] = useState(new UserModel());
    const [dropdownList, setDropdownList] = useState<DropDownList>(new DropDownListClass());
    const [AgencyId, setAgencyId] = useState<any>(0);
    const [DomainId, setDomainId] = useState<number>(0);

    const RoleId = [7];  // Super Admin role id : 7
    const [loginUserRoleId, setLoginUserRoleId] = useState(1);

    const [deleteImage, setDeleteImage] = useState<null | string>(null)
    const maxImageSize = 5;
    const imageTypes = ["jpg", "jpeg", "png"]
    const addPhoto = useRef<any>(null);
    const isAllFieldsDisabled = formData?.DomainMasterId === 0 || (![0, 1]?.includes(formData?.DomainMasterId) && AgencyId === 0);

    const AgencyDataList: any = useMemo(() =>
        formData?.DomainMasterId === 2 ?
            dropdownList?.travelAgentManagement :
            formData?.DomainMasterId === 3 ?
                dropdownList?.corporateManagement
                : []
        , [formData?.DomainMasterId, dropdownList])


    const handleimageupload = async (pathdirectory: any, filename: any, file: any) => {
        await ImageUpload(pathdirectory, filename, file);
    };

    const handleimageDelete = async (filename: any) => {
        await ImageDelete(filename);
    };

    useEffect(() => {
        async function fetchData() {
            if (location?.state != null) {
                const userData: any = GetLocalStorage();
                setFormData((form) => ({ ...form, UserId: userData?.userMasterID }))
                setEditDisabled(location?.state?.editdisabled);
                const statusoftoken = await verifytoken();
                if (statusoftoken) {
                    Promise.allSettled([
                        getGenderList(),
                        getDepartmentList(),
                        getProductList(),
                        getUserProfileImageRole(),
                        location?.state?.Id > 0 && handleRetrive(location?.state?.Id),
                    ])
                }
                else {
                    ClearLocalStorage();
                    dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                }
            }
            else {
                navigate('/Userlist')
            }
        }
        fetchData();
    }, [])


    const handleRetrive = async (id: number) => {
        setButtonAddEditText("Update");
        setEditDisabled(true)
        setPasswordType(true)
        setDisabled(true);
        const userlistdatabyid = await getAllData('/auth/v1/getmouserlistdatabyid?usermasterid=' + id);
        if (userlistdatabyid?.status && userlistdatabyid?.data) {
            const retrieveData = userlistdatabyid?.data?.[0];
            setFormData((form) => ({
                ...form,
                FirstName: retrieveData?.firstName,
                MiddleName: retrieveData?.middleName,
                LastName: retrieveData?.lastName,
                UserEmail: retrieveData?.email,
                ContactNo: retrieveData?.contactNo,
                GenderId: retrieveData?.genderId,
                UserName: retrieveData?.userName,
                RoleId: retrieveData?.roleId,
                DepartmentId: retrieveData?.departmentId,
                IsActive: retrieveData?.isActive,
                Password: retrieveData?.password,
                ConfirmPassword: retrieveData?.password,
                UserMasterId: retrieveData?.userMasterID,
                ImageName: retrieveData?.imageName,
                ImagePath: retrieveData?.imagePath,
                TravelCategoryId: retrieveData?.travelCategoryId,
                TravelType: retrieveData?.regionId?.length <= 0 && retrieveData?.subContinentId?.length <= 0 ? 0 : retrieveData?.regionId?.length > 0 ? 1 : 2,
                RegionId: retrieveData?.regionId ? retrieveData?.regionId : null,
                SubContinentId: retrieveData?.subContinentId ? retrieveData?.subContinentId : null,
                DomainMasterId: retrieveData?.domainMasterId ? retrieveData?.domainMasterId : 0,
                CorporateId: retrieveData?.corporateId ? retrieveData?.corporateId : null,
                TravelAgentId: retrieveData?.travelAgentId ? retrieveData?.travelAgentId : null,
            }))
            setDomainId(retrieveData?.domainMasterId ? retrieveData?.domainMasterId : 0)
            const agencyId = retrieveData?.domainMasterId === 1 ? 0 : (retrieveData?.domainMasterId === 2 ? retrieveData?.travelAgentId : (retrieveData?.domainMasterId === 3 ? retrieveData?.corporateId : 0))
            setAgencyId(agencyId)
            setActiveId(retrieveData?.isActive);
            setDeleteImage(retrieveData?.imagePath ? `https://static-ethics.sgp1.digitaloceanspaces.com/etm/${retrieveData?.imagePath}` : null);

        }
    }

    const getGenderList = async () => {
        const genderlist = await getAllData('/auth/v1/getusergenderlist')
        if (genderlist?.status) {
            genderlist?.data?.map((el: any) => {
                el.label = el?.Gender
                el.value = el?.GenderId
                return el;
            })
            setGenderList(genderlist?.data ? genderlist?.data : []);
        }
        else {
            setGenderList([]);
        }
    }

    const getDepartmentList = async () => {
        const departmentlist = await getAllData('/auth/v1/getmouserregistrationoptions?UserType=' + formData.UserType)
        if (departmentlist?.status) {
            setDropdownList(departmentlist?.data)
        }
        else {
            setDropdownList(new DropDownListClass())
        }
    }

    const getProductList = async () => {
        const productlist = await getAllData('/auth/v1/getproductlist')
        if (productlist?.status) {
            const ActiveProductList = productlist?.data?.productList?.filter((fil: any) => fil?.IsActive === true);
            ActiveProductList?.map((obj: any) => {
                obj.label = obj?.TravelCategoryName
                obj.value = obj?.TravelCategoryId
                return obj;
            })
            setProductList(ActiveProductList ? ActiveProductList : []);
        }
        else {
            setProductList([]);
        }
    }

    const getUserProfileImageRole = async () => {
        const userProfileImageRole = await getuserprofileimagebyid();
        if (userProfileImageRole?.status) {
            setLoginUserRoleId(userProfileImageRole?.data?.[0]?.RoleId);
        }
    }


    const handleOnChange = (name: string, value: any) => {
        setFormData({ ...formData, [name]: value });
        setFormErrors({});
        setEditDisabled(false);
    }

    const handleSelectChange = (name: string, value: number | number[] | undefined) => {
        setFormErrors({});
        setEditDisabled(false);
        if (name === "DomainMasterId") {
            setAgencyId(0);
            setFormData((form: any) => ({ ...form, DomainMasterId: value, TravelAgentId: null, CorporateId: null }));
        }
        else if (name === "AgencyId") {
            setAgencyId(value);
            setFormData((form: any) => ({ ...form, TravelAgentId: form?.DomainMasterId === 2 ? value : null, CorporateId: form?.DomainMasterId === 3 ? value : null }));
        }
        else if (name === "SubContinentId") {
            setFormData((form: any) => ({ ...form, SubContinentId: value, RegionId: null }));
        }
        else if (name === "RegionId") {
            setFormData((form: any) => ({ ...form, RegionId: value, SubContinentId: null }));
        }
        else if (name === "DepartmentId") {
            setFormData((form: any) => ({ ...form, DepartmentId: value, RoleId: 0 }));
        }
        else {
            setFormData((form: any) => ({ ...form, [name]: value }));
        }
    }

    const handleisActive = (e: any) => {
        if (buttonaddeditText === 'Add') {
            // formData.IsActive = e
            setFormData((form) => ({ ...form, IsActive: e }));
            setActiveId(!activeId);
            setFormErrors({});
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e: any) => {
        if (e === true) {
            // formData.IsActive = !activeId
            setFormData((form) => ({ ...form, IsActive: !activeId }));
            setEditDisabled(false);
            setActiveId(!activeId)
        }
        setModalShow(false);
    }


    const handleImageUpload = (e: any) => {
        setFormErrors({});
        setEditDisabled(false);
        const file = e.target.files?.[0];
        const fileID = getDateCombination();
        const fileName = fileID + '_1_' + (file?.name?.replace(/ /g, "_"))?.replace(/-/g, '');
        const filePath = `MO/UserProfile/${fileName}`;
        const path = `MO/UserProfile/`;

        const fileSize = (file?.size / 1024) / 1024;

        const length = file?.type?.split('/')?.length
        const fileType = file?.type?.split('/')?.[length - 1]?.toString()?.toLowerCase();


        setFormData((form) => ({
            ...form,
            ImageFile: file ? file : null,
            ImageName: file ? fileName : "",
            ImagePath: file ? filePath : "",
            Path: file ? path : "",
            Type: file ? fileType : "",
            Size: file ? fileSize : 0,
            needToUpload: file ? true : false
        }))
    }

    const handleRadioChange = (value: string) => {
        setFormErrors({});
        setEditDisabled(false);
        setFormData((form) => ({ ...form, TravelType: Number(value), RegionId: null, SubContinentId: null }));
    }

    const validateHighData = () => {
        let status = true;
        let error: any = {};

        if (formData?.DomainMasterId === 0) {
            error.DomainMasterId = "Please select Domain";
            status = false;
        }
        if (![0, 1]?.includes(formData?.DomainMasterId) && AgencyId === 0) {
            error.AgencyId = "Please select Agency";
            status = false;
        }

        setFormErrors(error);

        if (Object.keys(error).length > 0) {
            const id = Object.keys(error)[0];
            document.getElementById(id)?.focus();
        }
        return status;

    }

    const validateData = () => {
        const isValid = validateHighData();
        if (isValid) {
            let status = true;
            let error: any = {};


            if (formData.FirstName?.trim()?.length === 0 || formData.FirstName == null) {
                error.FirstName = "First name is required";
                status = false;
            }
            if (formData.LastName?.trim()?.length === 0 || formData.LastName == null) {
                error.LastName = " Last name is required";
                status = false;
            }
            if (formData.UserEmail?.trim()?.length === 0 || formData.UserEmail == null) {
                error.UserEmail = "Email Id is required";
                status = false;
            }
            if (formData.UserEmail?.trim()?.length > 0 && !isValidEmail(formData.UserEmail)) {
                error.UserEmail = "Email Id should in a format abc@xyz.com";
                status = false;
            }
            if (formData.ContactNo?.trim()?.length === 0 || formData.ContactNo == null) {
                error.ContactNo = "Mobile number is required";
                status = false;
            }
            if (formData.ContactNo?.trim()?.length > 0 && formData.ContactNo?.trim()?.length < 10) {
                error.ContactNo = "Mobile number should be 10 digit long";
                status = false;
            }
            if (formData.UserName?.trim()?.length === 0 || formData.UserName == null) {
                error.UserName = "Username is required";
                status = false;
            }

            if (formData?.TravelType === 0) {
                error.TravelType = "Input is mandatory";
                status = false;
            }
            if (formData?.TravelType === 2 && (formData?.SubContinentId === null || formData?.SubContinentId?.length <= 0)) {
                error.SubContinentId = "Please Select Sub Continent";
                status = false;
            }
            if (formData?.TravelType === 1 && (formData?.RegionId === null || formData?.RegionId?.length <= 0)) {
                error.RegionId = "Please Select Region";
                status = false;
            }

            if (formData.DepartmentId === 0) {
                error.DepartmentId = "Kindly select department name.";
                status = false;
            }
            if (formData.RoleId === 0) {
                error.RoleId = " Please select role";
                status = false;
            }
            if (formData?.TravelCategoryId?.length === 0) {
                error.TravelCategoryId = " Please select product";
                status = false;
            }
            if (formData.Password?.trim()?.length === 0 || formData.Password == null) {
                error.Password = "Kindly enter the password";
                status = false;
            }
            if (formData.Password?.trim()?.length > 0 && (CheckPassword(formData.Password) === false || formData.Password?.trim()?.length < 8)) {
                error.Password = "Password must contain at least 1 upper case, 1 number, 1 special character and minimum 8 character long";
                status = false;
            }
            if (formData.Password?.trim()?.length > 0 && formData.ConfirmPassword?.trim()?.length === 0) {
                error.ConfirmPassword = " Kindly re-enter the password";
                status = false;
            }
            if (formData.ConfirmPassword?.trim()?.length > 0 && formData.Password?.trim()?.length > 0 && formData.Password !== formData.ConfirmPassword) {
                error.ConfirmPassword = "Enter password mismatch";
                status = false;
            }

            if (formData?.ImageName !== "" && formData?.ImageFile !== null && !imageTypes?.includes(formData?.Type)) {
                error.addphoto = "Please select file type as JPG, JPEG, & PNG.";
                status = false;
            }

            if (formData?.ImageName !== "" && formData?.ImageFile !== null && imageTypes?.includes(formData?.Type) && formData?.Size > maxImageSize) {
                error.addphoto = "Cannot upload. The selected image exceed the maximum limit of 5 MB.";
                status = false;
            }

            setFormErrors(error);

            if (Object.keys(error).length > 0) {
                const id = Object.keys(error)[0];
                document.getElementById(id)?.focus();
            }
            return status;

        }
    }


    const handlesavadata = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const UserData = await postUsersData("/auth/v1/insertorupdateadminuserlist", formData);

                if (UserData?.status) {
                    if (formData?.needToUpload) {
                        Promise.allSettled([
                            deleteImage !== null && await handleimageDelete(deleteImage),
                            await handleimageupload(formData?.Path, formData?.ImageName, formData?.ImageFile)
                        ])
                    }
                    dispatch({ type: 'ALERTINGMESSAGE', message: UserData?.message })
                    clearData();
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: UserData?.message })
                    dispatch(loaderActions.end());
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }

    }
    const clearData = () => {
        setButtonAddEditText("Add")
        setFormErrors({});
        setFormData((form) => ({
            ...form,
            DomainMasterId: 0,
            TravelAgentId: null,
            CorporateId: null,
            FirstName: '',
            MiddleName: '',
            LastName: '',
            UserEmail: '',
            ContactNo: '',
            GenderId: 0,
            UserName: '',
            RoleId: 0,
            DepartmentId: 0,
            IsActive: false,
            Password: '',
            ConfirmPassword: '',
            UserMasterId: 0,
            ImageName: "",
            ImagePath: "",
            Path: "",
            ImageFile: {},
            Type: "",
            Size: 0,
            needToUpload: false,
            TravelCategoryId: [],
            TravelType: 0,
            SubContinentId: [],
            RegionId: [],
        }))
        setActiveId(false);
        setEditDisabled(false);

        if (addPhoto?.current !== null) {
            addPhoto.current.value = "";
        }
    }


    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{location?.state?.menuTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <h3>User Registration</h3>
            </div>
            <div className="m-2">
                <form action="" className='mt-3'>
                    <div className="row mx-1 mb-4">
                        <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <label htmlFor="DomainMasterId" className="col-form-label required">Select Domain</label>
                                </div>
                                <div className=" col-lg-8 col-md-12 col-sm-12">
                                    <Select
                                        className="dropdown select_dropdown custom_class"
                                        options={dropdownList?.domainMaster}
                                        inputId='DomainMasterId'
                                        value={dropdownList?.domainMaster?.filter((item) => item?.value === formData?.DomainMasterId) || 0}// set list of the data
                                        onChange={(e) => handleSelectChange("DomainMasterId", e?.value)} // assign onChange function
                                        isDisabled={DomainId > 0}
                                        isSearchable
                                        placeholder="Select Domain"
                                    />
                                    {formErrors?.DomainMasterId && <div className='text-danger text-start fs_14'>{formErrors?.DomainMasterId}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <label htmlFor="AgencyId" className={`col-form-label ${![0, 1]?.includes(formData?.DomainMasterId) ? 'required' : ''}`}>Select Agency</label>
                                </div>
                                <div className=" col-lg-8 col-md-12 col-sm-12">
                                    <Select
                                        className="dropdown select_dropdown custom_class"
                                        options={AgencyDataList}
                                        inputId='AgencyId'
                                        value={AgencyDataList?.filter((item: any) => item?.value === AgencyId) || null}// set list of the data
                                        onChange={(e) => handleSelectChange("AgencyId", e?.value)} // assign onChange function
                                        isDisabled={DomainId > 0 || [0, 1]?.includes(formData?.DomainMasterId)}
                                        isSearchable
                                        placeholder="Select Agency"
                                    />
                                    {formErrors?.AgencyId && <div className='text-danger text-start fs_14'>{formErrors?.AgencyId}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <fieldset disabled={isAllFieldsDisabled} >
                        <div className="mb-3 row mx-1">
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="FirstName" className="col-form-label required">First Name</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <input type="text" id="FirstName" className="form-control"
                                            name="FirstName"
                                            maxLength={20}
                                            value={formData.FirstName}
                                            onChange={(e) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                            // disabled={disabled ? true : false}
                                            placeholder="First Name"
                                        />
                                        {formErrors.FirstName && <div className='text-danger text-start fs_14'>{formErrors.FirstName}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="MiddleName" className="col-form-label">Middle Name</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <input type="text" id="MiddleName" className="form-control"
                                            name="MiddleName"
                                            maxLength={20}
                                            value={formData.MiddleName}
                                            onChange={(e) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                            // disabled={disabled ? true : false}
                                            placeholder="Middle Name"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="LastName" className="col-form-label required">Last Name</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <input type="text" id="LastName" className="form-control"
                                            name="LastName"
                                            maxLength={20}
                                            value={formData.LastName}
                                            onChange={(e) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                            // disabled={disabled ? true : false}
                                            placeholder="Last Name"
                                        />
                                        {formErrors?.LastName && <div className='text-danger text-start fs_14'>{formErrors?.LastName}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="UserEmail" className="col-form-label required">Email ID</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <input type="text" id="UserEmail" className="form-control"
                                            name="UserEmail"
                                            maxLength={150}
                                            value={formData.UserEmail}
                                            onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                            // disabled={disabled ? true : false}
                                            placeholder="Email ID"
                                        />
                                        {formErrors?.UserEmail && <div className='text-danger text-start fs_14'>{formErrors?.UserEmail}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="ContactNo" className="col-form-label required">Mobile No.</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">

                                        <div className="input-group">
                                            <span className="input-group-text" id="prefixMobile"> +91 </span>
                                            <input className="form-control" id='ContactNo' type="text"
                                                name="ContactNo"
                                                maxLength={10}
                                                value={formData.ContactNo}
                                                onChange={(e) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                                // disabled={disabled ? true : false}
                                                placeholder="Mobile Number"
                                            />
                                        </div>
                                        {formErrors?.ContactNo && <div className='text-danger text-start fs_14'>{formErrors?.ContactNo}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="genderid" className="col-form-label">Gender</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Select
                                            id='genderid'
                                            className="dropdown select_dropdown custom_class"
                                            options={GenderList}
                                            value={GenderList?.filter((item: SelectList) => item?.value === formData?.GenderId)}
                                            isSearchable
                                            placeholder="Gender"
                                            onChange={(e) => handleSelectChange("GenderId", e?.value)} // assign onChange function
                                            isDisabled={isAllFieldsDisabled}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="UserName" className="col-form-label required">User Name</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <input type="text" id="UserName" className="form-control"
                                            name="UserName"
                                            value={formData.UserName}
                                            maxLength={30}
                                            onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                            disabled={disable}
                                            placeholder="User Name"
                                        />
                                        {formErrors?.UserName && <div className='text-danger text-start fs_14'>{formErrors?.UserName}</div>}
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <div className="required">
                                            India | International
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-12 col-sm-12 row">
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    id="india"
                                                    className="form-check-input"
                                                    name="domint"
                                                    checked={formData?.TravelType === 1}
                                                    value={1}
                                                    onChange={(e) => handleRadioChange(e.target.value)}
                                                />
                                                <label htmlFor="india" className="form-check-label"> India </label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    id="international"
                                                    className="form-check-input"
                                                    name="domint"
                                                    value={2}
                                                    checked={formData?.TravelType === 2}
                                                    onChange={(e) => handleRadioChange(e.target.value)}
                                                />
                                                <label htmlFor="international" className="form-check-label"> International </label>
                                            </div>
                                        </div>
                                        {formErrors?.TravelType && <div className='text-danger text-center fs_14'>{formErrors?.TravelType}</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="SubContinentId" className={`col-form-label ${formData?.TravelType === 2 ? "required" : ""}`}>Sub Continent</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Select
                                            inputId='SubContinentId'
                                            className="dropdown select_dropdown custom_class"
                                            options={locationsData?.subContinentData}
                                            value={locationsData?.subContinentData?.filter((fil) => formData?.SubContinentId?.includes(fil?.value))}
                                            isSearchable
                                            isMulti
                                            closeMenuOnSelect={false}
                                            placeholder="Sub Continent"
                                            onChange={(e) => handleSelectChange("SubContinentId", e?.map((obj: any) => obj?.value))} // assign onChange function
                                            isDisabled={formData?.TravelType !== 2 || isAllFieldsDisabled}
                                        />
                                        {formErrors?.SubContinentId && <div className='text-danger text-start fs_14'>{formErrors?.SubContinentId}</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="RegionId" className={`col-form-label ${formData?.TravelType === 1 ? "required" : ""}`}>Region</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Select
                                            inputId='RegionId'
                                            className="dropdown select_dropdown custom_class"
                                            options={locationsData?.regionData}
                                            value={locationsData?.regionData?.filter((fil) => formData?.RegionId?.includes(fil?.value))}
                                            isSearchable
                                            isMulti
                                            closeMenuOnSelect={false}
                                            placeholder="Region"
                                            onChange={(e) => handleSelectChange("RegionId", e?.map((obj: any) => obj?.value))} // assign onChange function
                                            isDisabled={formData?.TravelType !== 1 || isAllFieldsDisabled}
                                        />
                                        {formErrors?.RegionId && <div className='text-danger text-start fs_14'>{formErrors?.RegionId}</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Department</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Select
                                            className="dropdown select_dropdown custom_class"
                                            options={dropdownList?.departmentRoleList}
                                            inputId='DepartmentId'
                                            value={dropdownList?.departmentRoleList?.filter((item: SelectList) => item?.value === formData?.DepartmentId)}// set list of the data
                                            onChange={(e) => handleSelectChange("DepartmentId", e?.value)} // assign onChange function
                                            isDisabled={isAllFieldsDisabled}
                                            isSearchable={true}
                                            placeholder="Department"
                                        />
                                        {formErrors?.DepartmentId && <div className='text-danger text-start fs_14'>{formErrors?.DepartmentId}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Role</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Select
                                            className="dropdown select_dropdown custom_class"
                                            options={dropdownList?.departmentRoleList?.find((fin) => fin?.value === formData?.DepartmentId)?.departmentRoleList}
                                            inputId='RoleId'
                                            value={dropdownList?.departmentRoleList?.find((fin) => fin?.value === formData?.DepartmentId)?.departmentRoleList?.filter((item: SelectList) => item?.value === formData?.RoleId) || null}// set list of the data
                                            onChange={(e) => handleSelectChange("RoleId", e?.value)} // assign onChange function
                                            isDisabled={(formData?.DepartmentId > 0 ? false : true) || isAllFieldsDisabled}
                                            isSearchable={true}
                                            placeholder="Role"
                                        />
                                        {formErrors?.RoleId && <div className='text-danger text-start fs_14'>{formErrors?.RoleId}</div>}
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="TravelCategoryId" className="col-form-label required">Product</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Select
                                            inputId='TravelCategoryId'
                                            className="dropdown select_dropdown custom_class"
                                            options={ProductList}
                                            value={ProductList?.filter((fil) => formData?.TravelCategoryId?.includes(fil?.value))}
                                            isSearchable
                                            isMulti
                                            closeMenuOnSelect={false}
                                            placeholder="Product"
                                            onChange={(e) => handleSelectChange("TravelCategoryId", e?.map((obj: any) => obj?.value))} // assign onChange function
                                            isDisabled={isAllFieldsDisabled}
                                        />
                                        {formErrors?.TravelCategoryId && <div className='text-danger text-start fs_14'>{formErrors?.TravelCategoryId}</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Password</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        {
                                            passwordType && RoleId?.includes(loginUserRoleId) ?
                                                <PasswordInput
                                                    id='Password'
                                                    name='Password'
                                                    value={formData.Password}
                                                    onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                                    placeholder='Password'
                                                    maxLength={15}
                                                />
                                                :
                                                <input type={`${passwordType ? 'password' : 'text'}`} id="Password" className="form-control"
                                                    name="Password"
                                                    autoComplete='off'
                                                    value={formData.Password}
                                                    onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                                    disabled={disable}
                                                    placeholder="Password"
                                                    maxLength={15}
                                                />
                                        }

                                        {formErrors?.Password && <div className='text-danger text-start fs_14'>{formErrors?.Password}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="ConfirmPassword" className="col-form-label required">Confirm Password</label>
                                    </div>
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        {
                                            passwordType && RoleId?.includes(loginUserRoleId) ?
                                                <PasswordInput
                                                    id='ConfirmPassword'
                                                    name='ConfirmPassword'
                                                    value={formData.ConfirmPassword}
                                                    onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                                    placeholder='Confirm Password'
                                                    maxLength={15}
                                                />
                                                :
                                                <input type={`${passwordType ? 'password' : 'text'}`} id="ConfirmPassword" className="form-control"
                                                    name="ConfirmPassword"
                                                    autoComplete='off'
                                                    value={formData.ConfirmPassword}
                                                    onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                                    disabled={disable}
                                                    placeholder="Confirm Password"
                                                    maxLength={15}
                                                />
                                        }

                                        {formErrors.ConfirmPassword && <div className='text-danger text-start fs_14'>{formErrors.ConfirmPassword}</div>}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <Switch
                                            onChange={handleisActive}
                                            checked={activeId}
                                            className="react-switch"
                                            disabled={isAllFieldsDisabled}
                                        />
                                    </div>
                                    <ConfirmationModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                        noconfirm={() => handleConfirmation(false)}
                                        yesconfirm={() => handleConfirmation(true)}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="addphoto" className="col-form-label">Add Photo</label>
                                    </div>
                                    <div className="col-lg-8 col-md-12 col-sm-12">
                                        <input
                                            ref={addPhoto}
                                            className='form-control btn_add'
                                            type="file"
                                            name="addphoto"
                                            id="addphoto"
                                            placeholder='Browse Picture'
                                            accept='.jpeg,.jpg,.png'
                                            onChange={(e: any) => handleImageUpload(e)}
                                        />
                                        {formData?.ImageName && <div className='text-start fs_14'> {formData?.ImageName} </div>}
                                        {formErrors?.addphoto && <div className='text-danger text-start fs_14'>{formErrors?.addphoto}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div className="d-flex justify-content-center">
                        <button type="button" className="btn btn-primary mx-1" onClick={handlesavadata} disabled={editdisabled} id="btnAdd" >{buttonaddeditText}</button>
                        <button type="button" className="btn btn-primary mx-1" disabled={disable || isAllFieldsDisabled} onClick={clearData} id="btnClear" >Clear</button>
                        <button type="button" className="btn btn-primary mx-1" onClick={() => navigate('/Userlist')} id="btnClear" >Back</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Useradd